import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#0A0A14] text-[#F0EFF8]" style={{ fontFamily: 'Sora, sans-serif' }}>
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A14]/80 backdrop-blur-xl border-b border-white/[0.06]">
        <div className="max-w-[1400px] mx-auto px-8 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/601b8a805a2f0f27f21e1ce6d1f2a810/80ae8f6d2d425f94fe707693601f876c.png"
              alt="Intevo Labs"
              className="h-9 w-auto"
            />
          </Link>
          <Link
            to="/"
            className="px-6 py-3 bg-[#7B3FE4] hover:bg-[#6B2FD4] text-white font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
            style={{ borderRadius: '2px', fontSize: '14px' }}
          >
            Volver al inicio
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="pt-32 pb-20">
        <div className="max-w-[900px] mx-auto px-8">
          {/* Page Title */}
          <div className="mb-16">
            <h1 className="text-5xl font-bold mb-6" style={{ lineHeight: '1.2' }}>
              Política de Privacidad
            </h1>
            <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
              Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            {/* Section 1 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                1. Introducción
              </h2>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                En Intevo Labs, nos comprometemos a proteger tu privacidad y garantizar la seguridad de tus datos personales. Esta Política de Privacidad describe cómo recopilamos, usamos, almacenamos y protegemos la información que nos proporcionas al utilizar nuestros servicios de automatización con inteligencia artificial.
              </p>
              <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Al acceder o utilizar nuestros servicios, aceptas las prácticas descritas en esta política. Si no estás de acuerdo con alguno de los términos, te recomendamos no utilizar nuestros servicios.
              </p>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                2. Información que Recopilamos
              </h2>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Recopilamos diferentes tipos de información para proporcionar y mejorar nuestros servicios:
              </p>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    2.1 Información que nos proporcionas directamente
                  </h3>
                  <ul className="list-disc list-inside space-y-2 text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    <li>Nombre completo y datos de contacto (correo electrónico, teléfono)</li>
                    <li>Información de tu empresa (nombre, sector, tamaño)</li>
                    <li>Detalles sobre tus procesos de negocio y necesidades de automatización</li>
                    <li>Información técnica sobre tu stack tecnológico actual</li>
                    <li>Comunicaciones que mantienes con nosotros</li>
                  </ul>
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    2.2 Información recopilada automáticamente
                  </h3>
                  <ul className="list-disc list-inside space-y-2 text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    <li>Datos de uso del sitio web (páginas visitadas, tiempo de navegación)</li>
                    <li>Información del dispositivo (tipo, sistema operativo, navegador)</li>
                    <li>Dirección IP y datos de ubicación general</li>
                    <li>Cookies y tecnologías similares</li>
                  </ul>
                </div>
              </div>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                3. Cómo Utilizamos tu Información
              </h2>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Utilizamos la información recopilada para los siguientes propósitos:
              </p>
              <ul className="list-disc list-inside space-y-2 text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                <li>Proporcionar, mantener y mejorar nuestros servicios de automatización con IA</li>
                <li>Realizar diagnósticos y análisis de tus procesos de negocio</li>
                <li>Diseñar e implementar soluciones personalizadas para tu empresa</li>
                <li>Comunicarnos contigo sobre nuestros servicios, actualizaciones y soporte técnico</li>
                <li>Procesar tus solicitudes y responder a tus consultas</li>
                <li>Analizar el uso de nuestro sitio web para mejorar la experiencia del usuario</li>
                <li>Cumplir con obligaciones legales y proteger nuestros derechos</li>
                <li>Prevenir fraudes y garantizar la seguridad de nuestros sistemas</li>
              </ul>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                4. Cookies y Tecnologías Similares
              </h2>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Utilizamos cookies y tecnologías similares para mejorar tu experiencia en nuestro sitio web. Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo cuando visitas nuestro sitio.
              </p>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    Tipos de cookies que utilizamos:
                  </h3>
                  <ul className="list-disc list-inside space-y-2 text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    <li><strong>Cookies esenciales:</strong> Necesarias para el funcionamiento básico del sitio</li>
                    <li><strong>Cookies de rendimiento:</strong> Nos ayudan a entender cómo los usuarios interactúan con nuestro sitio</li>
                    <li><strong>Cookies de funcionalidad:</strong> Permiten recordar tus preferencias</li>
                    <li><strong>Cookies de marketing:</strong> Utilizadas para mostrar contenido relevante</li>
                  </ul>
                </div>
                <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                  Puedes configurar tu navegador para rechazar todas las cookies o para que te avise cuando se envíe una cookie. Sin embargo, algunas funciones del sitio pueden no funcionar correctamente sin cookies.
                </p>
              </div>
            </section>

            {/* Section 5 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                5. Compartir tu Información
              </h2>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                No vendemos ni alquilamos tu información personal a terceros. Podemos compartir tu información únicamente en las siguientes circunstancias:
              </p>
              <ul className="list-disc list-inside space-y-2 text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                <li><strong>Proveedores de servicios:</strong> Con empresas que nos ayudan a operar nuestro negocio (hosting, análisis, soporte técnico)</li>
                <li><strong>Requisitos legales:</strong> Cuando sea necesario para cumplir con la ley o proteger nuestros derechos</li>
                <li><strong>Transferencias de negocio:</strong> En caso de fusión, adquisición o venta de activos</li>
                <li><strong>Con tu consentimiento:</strong> Cuando nos autorices explícitamente a compartir tu información</li>
              </ul>
            </section>

            {/* Section 6 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                6. Seguridad de los Datos
              </h2>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Implementamos medidas de seguridad técnicas y organizativas apropiadas para proteger tu información personal contra acceso no autorizado, alteración, divulgación o destrucción. Estas medidas incluyen:
              </p>
              <ul className="list-disc list-inside space-y-2 text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                <li>Cifrado de datos en tránsito y en reposo</li>
                <li>Controles de acceso estrictos y autenticación multifactor</li>
                <li>Auditorías de seguridad regulares</li>
                <li>Capacitación continua de nuestro equipo en prácticas de seguridad</li>
                <li>Monitoreo constante de nuestros sistemas</li>
              </ul>
              <p className="text-[#8887A0] mt-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Sin embargo, ningún método de transmisión por Internet o almacenamiento electrónico es 100% seguro. Aunque nos esforzamos por proteger tu información, no podemos garantizar su seguridad absoluta.
              </p>
            </section>

            {/* Section 7 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                7. Tus Derechos
              </h2>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Tienes los siguientes derechos respecto a tu información personal:
              </p>
              <ul className="list-disc list-inside space-y-2 text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                <li><strong>Acceso:</strong> Solicitar una copia de la información que tenemos sobre ti</li>
                <li><strong>Rectificación:</strong> Corregir información inexacta o incompleta</li>
                <li><strong>Eliminación:</strong> Solicitar la eliminación de tu información personal</li>
                <li><strong>Restricción:</strong> Limitar el procesamiento de tu información</li>
                <li><strong>Portabilidad:</strong> Recibir tu información en un formato estructurado y de uso común</li>
                <li><strong>Oposición:</strong> Oponerte al procesamiento de tu información para ciertos fines</li>
                <li><strong>Retirar consentimiento:</strong> Retirar tu consentimiento en cualquier momento</li>
              </ul>
              <p className="text-[#8887A0] mt-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Para ejercer cualquiera de estos derechos, contáctanos a través de los medios indicados en la sección de contacto.
              </p>
            </section>

            {/* Section 8 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                8. Retención de Datos
              </h2>
              <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Conservamos tu información personal solo durante el tiempo necesario para cumplir con los propósitos descritos en esta política, a menos que la ley requiera o permita un período de retención más largo. Los criterios para determinar el período de retención incluyen:
              </p>
              <ul className="list-disc list-inside space-y-2 text-[#8887A0] mt-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                <li>La duración de nuestra relación comercial contigo</li>
                <li>Requisitos legales o regulatorios aplicables</li>
                <li>Necesidades de resolución de disputas o cumplimiento legal</li>
              </ul>
            </section>

            {/* Section 9 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                9. Transferencias Internacionales
              </h2>
              <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Tu información puede ser transferida y almacenada en servidores ubicados fuera de tu país de residencia. Cuando transferimos información a otros países, implementamos salvaguardas apropiadas para garantizar que tu información esté protegida de acuerdo con esta política y las leyes aplicables.
              </p>
            </section>

            {/* Section 10 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                10. Cambios a esta Política
              </h2>
              <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Podemos actualizar esta Política de Privacidad periódicamente para reflejar cambios en nuestras prácticas o por razones legales, operativas o regulatorias. Te notificaremos sobre cambios significativos publicando la nueva política en nuestro sitio web y actualizando la fecha de "Última actualización" en la parte superior de esta página. Te recomendamos revisar esta política regularmente.
              </p>
            </section>

            {/* Section 11 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                11. Contacto
              </h2>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Si tienes preguntas, inquietudes o solicitudes relacionadas con esta Política de Privacidad o el manejo de tu información personal, puedes contactarnos a través de:
              </p>
              <div className="bg-white/[0.02] border border-white/[0.06] p-6" style={{ borderRadius: '2px' }}>
                <p className="text-[#F0EFF8] mb-2" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                  <strong>Intevo Labs</strong>
                </p>
                <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                  Correo electrónico: hola@intevolabs.com
                </p>
                <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                  Formulario de contacto: Disponible en nuestra página principal
                </p>
              </div>
              <p className="text-[#8887A0] mt-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Nos comprometemos a responder a tu solicitud en un plazo razonable y, en cualquier caso, dentro de los plazos establecidos por la legislación aplicable.
              </p>
            </section>
          </div>

          {/* Back to Home Link */}
          <div className="mt-16 pt-8 border-t border-white/[0.06]">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-[#7B3FE4] hover:text-[#9B6FE4] transition-colors duration-200 cursor-pointer"
              style={{ fontSize: '16px', fontWeight: '600' }}
            >
              <i className="ri-arrow-left-line"></i>
              Volver al inicio
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}